module.exports = "<div class=\"wrapper wrapper-sm\">\n    <section class=\"page\">\n        <div class=\"page-content\">\n            <div class=\"box p1 lg-pxl bb1 mbxl\">\n                <div class=\"box-body\">\n                    <h1 class=\"h2 mt0\"><span class=\"page-heading h4 text-upper\">404 Error</span><br>Page Not Found</h1>\n                    <p class=\"mb0\">It seems the page you are looking for does not exist. Have you tried a search?</p>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/templates/404.html
// module id = 101
// module chunks = 0